const LARGE_VIEWPORT_WIDTH = 1400;

export class Util {
	readFromDataAttribute(element, dataName) {
		return element.dataset ? element.dataset[dataName] : element.getAttribute(`data-${dataName}`); /*                    */
	}

	isWideViewport() {
		return window.innerWidth > LARGE_VIEWPORT_WIDTH;
	}
}
